import {
    isCondominium,
    isCottage,
    isHouse,
    isHousingCooperative,
    NestedHome,
} from "@habity/types";

export const isInspected = (home: NestedHome) => {
    const { provider_data, provider_type } = home || {};
    if (!provider_data || !provider_type) return false;
    if (
        isHouse(provider_data, provider_type) ||
        isCottage(provider_data, provider_type) ||
        isCondominium(provider_data, provider_type) ||
        isHousingCooperative(provider_data, provider_type)
    ) {
        // @ts-ignore
        const { inspection } = provider_data || {};
        const { inspected } = inspection || {};
        return inspected;
    }
    return false;
};

export const isInsured = (home: NestedHome) => {
    const { provider_data, provider_type } = home || {};
    if (!provider_data || !provider_type) return false;
    if (
        isHouse(provider_data, provider_type) ||
        isCottage(provider_data, provider_type) ||
        isCondominium(provider_data, provider_type) ||
        isHousingCooperative(provider_data, provider_type)
    ) {
        // @ts-ignore
        const { inspection } = provider_data || {};
        const { sellerInsurence } = inspection || {};
        return sellerInsurence;
    }
    return false;
};
